import { lazy } from 'react';

// After a deploy the page files get new hashed names. A tab that was open
// before still runs the old app and asks for the old file, which is gone
// (404: "Failed to fetch dynamically imported module"), and the screen stays
// blank. When that happens, reload once so the tab picks up the new version;
// a second failure within RELOAD_GUARD_MS is a real error and is rethrown.

const KEY = 'runvya:chunk-reload-at';
const RELOAD_GUARD_MS = 10000;

// indirection so tests can observe the reload
export const reloader = { reload: () => window.location.reload() };

export const isChunkLoadError = (error) => {
  const text = `${error?.name || ''} ${error?.message || ''}`;
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError/i.test(text);
};

export const reloadOnceForNewVersion = () => {
  let last = 0;
  try {
    last = Number(window.sessionStorage.getItem(KEY) || 0);
  } catch (e) {
    last = 0;
  }
  if (Date.now() - last < RELOAD_GUARD_MS) return false;
  try {
    window.sessionStorage.setItem(KEY, String(Date.now()));
  } catch (e) {
    // without storage we still reload; the guard just cannot remember it
  }
  reloader.reload();
  return true;
};

const lazyWithReload = (factory) => lazy(() => factory().catch((error) => {
  if (isChunkLoadError(error) && reloadOnceForNewVersion()) {
    return new Promise(() => {}); // the page is reloading; render nothing meanwhile
  }
  throw error;
}));

export default lazyWithReload;
